/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'ngx-bootstrap/tabs/ng-transclude.directive';
import * as i3 from 'ngx-bootstrap/tabs/tabset.component';
import * as i4 from 'ngx-bootstrap/tabs/tabset.config';
const styles_TabsetComponent:any[] = ([] as any[]);
export const RenderType_TabsetComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_TabsetComponent,data:{}});
function View_TabsetComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'span',[['class',
      'bs-remove-tab']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      $event.preventDefault();
      const pd_0:any = ((<any>_co.removeTab((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),[' ❌']))],(null as any),
      (null as any));
}
function View_TabsetComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),13,'li',([] as any[]),
      [[2,'active',(null as any)],[2,'disabled',(null as any)]],(null as any),(null as any),
      (null as any),(null as any))),i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,'ngClass']},(null as any)),
      i0.ɵpad(2,2),(_l()(),i0.ɵted(-1,(null as any),[' '])),(_l()(),i0.ɵeld(4,0,(null as any),
          (null as any),8,'a',[['class','nav-link'],['href','javascript:void(0);']],
          [[1,'id',0],[2,'active',(null as any)],[2,'disabled',(null as any)]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>(_v.context.$implicit.active = true)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),[' '])),
      (_l()(),i0.ɵeld(6,16777216,(null as any),(null as any),2,'span',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(7,16384,(null as any),0,i2.NgTranscludeDirective,[i0.ViewContainerRef],
          {ngTransclude:[0,'ngTransclude']},(null as any)),(_l()(),i0.ɵted(8,(null as any),
          ['',''])),(_l()(),i0.ɵted(-1,(null as any),[' '])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_TabsetComponent_2)),i0.ɵdid(11,
          16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),[' '])),(_l()(),
          i0.ɵted(-1,(null as any),[' ']))],(_ck,_v) => {
    const currVal_2:any = _ck(_v,2,0,'nav-item',(_v.context.$implicit.customClass || ''));
    _ck(_v,1,0,currVal_2);
    const currVal_6:any = _v.context.$implicit.headingRef;
    _ck(_v,7,0,currVal_6);
    const currVal_8:any = _v.context.$implicit.removable;
    _ck(_v,11,0,currVal_8);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.active;
    const currVal_1:any = _v.context.$implicit.disabled;
    _ck(_v,0,0,currVal_0,currVal_1);
    const currVal_3:any = (_v.context.$implicit.id? (_v.context.$implicit.id + '-link'): '');
    const currVal_4:any = _v.context.$implicit.active;
    const currVal_5:any = _v.context.$implicit.disabled;
    _ck(_v,4,0,currVal_3,currVal_4,currVal_5);
    const currVal_7:any = _v.context.$implicit.heading;
    _ck(_v,8,0,currVal_7);
  });
}
export function View_TabsetComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'ul',[['class',
      'nav']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    if (('click' === en)) {
      const pd_0:any = ((<any>$event.preventDefault()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),[' '])),(_l()(),
      i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_TabsetComponent_1)),
      i0.ɵdid(4,802816,(null as any),0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted(-1,
          (null as any),[' '])),(_l()(),i0.ɵted(-1,(null as any),[' '])),(_l()(),i0.ɵeld(7,
          0,(null as any),(null as any),3,'div',[['class','tab-content']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
          (null as any),[' '])),i0.ɵncd((null as any),0),(_l()(),i0.ɵted(-1,(null as any),
          [' '])),(_l()(),i0.ɵted(-1,(null as any),[' ']))],(_ck,_v) => {
    var _co:i3.TabsetComponent = _v.component;
    const currVal_0:any = 'nav';
    const currVal_1:any = _co.classMap;
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_2:any = _co.tabs;
    _ck(_v,4,0,currVal_2);
  },(null as any));
}
export function View_TabsetComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'tabset',([] as any[]),
      [[2,'tab-container',(null as any)]],(null as any),(null as any),View_TabsetComponent_0,
      RenderType_TabsetComponent)),i0.ɵdid(1,180224,(null as any),0,i3.TabsetComponent,
      [i4.TabsetConfig,i0.Renderer2],(null as any),(null as any))],(null as any),(_ck,
      _v) => {
    const currVal_0:any = i0.ɵnov(_v,1).clazz;
    _ck(_v,0,0,currVal_0);
  });
}
export const TabsetComponentNgFactory:i0.ComponentFactory<i3.TabsetComponent> = i0.ɵccf('tabset',
    i3.TabsetComponent,View_TabsetComponent_Host_0,{vertical:'vertical',justified:'justified',
        type:'type'},{},['*']);
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/~/ngx-bootstrap/tabs/tabset.component.ngfactory.ts